// ページトップ
import commonClass from "./commonClass";

export default class pageTop extends commonClass {
  // コンストラクタ
  constructor() {
    super();
    this._getSuper();
    this._classValiableDefine();

    this._init();
  }

  // 親classから変数を取得してくる
  _getSuper() {
  }
  // class変数定義
  _classValiableDefine() {
    this._$pageTopBtn = $('.js-pagetop');
    this._$fixedNav = $('.c-fnav');
    this._defPosFromBtm = 20;
    this._scrollSpeed = 500;
    this._fadeInSpeed = 200;
  }


  // 初期化用関数
  _init() {
    this._main();
  }

  // リサイズ用関数
  _resize() {
  }

  // メイン処理
  _main() {
    var cls = this;

    cls._setPosition();
    cls._addMoveToTop();
  }

  // fixedナビの有無チェック + ボタンのポジションを設定
  _setPosition() {
    var cls = this;

    if (cls._$fixedNav.length >  0) {
      cls._$pageTopBtn.css('bottom', cls._$fixedNav.outerHeight() + cls._defPosFromBtm);
    }

    cls._$pageTopBtn.fadeIn(cls._fadeInSpeed);
  }

  // トップへのイベントを付与
  _addMoveToTop() {
    var cls = this;

    cls._$pageTopBtn.on('click', function() {
      $('body, html').stop().animate({scrollTop: 0}, cls._scrollSpeed);
      return false;
    });
  }

}